import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  ListItemText,
  Divider,
  TextField,
  Grid,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import * as Yup from "yup";
import * as React from "react";
import { colors } from "../constants/constants";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Formik, Form } from "formik";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
const validationSchema = Yup.object().shape({
  licenseNumber: Yup.string().required("Add license"),
  issuedDate: Yup.date().required("Add issued  date"),
  expiryDate: Yup.date().required("Add expiry  date"),
  authorizedEquipment: Yup.object().shape({
    label: Yup.string().required("Select equipment"),
  }),
});

interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  selections: any;
  editData: any;
  handleOnSubmit: any;
  onClose: any;
}
class AddLicenseDetailsDialog extends React.Component<Props> {
  handleClose = () => {
    this.props.onClose();
  };
  handleDateChange = (id: any, date: any, setFieldValue: any) => {
    setFieldValue(id, date);
  };
  handleListItemClick = () => {
    this.props.onClose();
  };
  renderForm = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    isValid: any,
    touched: any,
    setFieldValue: any
  ) => {
    const { selections, editData } = this.props;
    let currentDay = new Date();
    currentDay = new Date(currentDay.setDate(currentDay.getDate() + 1));
    return (
      <Form>
        <TextField
          id={"licenseNumber"}
          label={"License Number"}
          onBlur={handleBlur}
          style={{ margin: 10 }}
          value={values.licenseNumber}
          onChange={handleChange}
          fullWidth
          error={errors.licenseNumber ? true : false}
          helperText={errors.licenseNumber}
          name={"licenseNumber"}
        />
        <Grid container justify={"space-between"}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              style={{ margin: 10 }}
              disableToolbar
              variant="inline"
              format="dd MMM yyyy"
              margin="normal"
              disableFuture={true}
              autoOk={true}
              id="issuedDate"
              label={"Issued date"}
              value={values.issuedDate}
              onChange={(e) => setFieldValue("issuedDate", e?.toDateString())}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              style={{ margin: 10 }}
              disableToolbar
              variant="inline"
              format="dd MMM yyyy"
              margin="normal"
              autoOk={true}
              disablePast={true}
              minDate={currentDay}
              id="expiryDate"
              label={"Expiry date"}
              value={values.expiryDate}
              onChange={(e) => setFieldValue("expiryDate", e?.toDateString())}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Autocomplete
          id={"authorizedEquipment"}
          freeSolo
          options={selections}
          onChange={(event: any, value: any) => {
            setFieldValue("authorizedEquipment", value);
          }}
          defaultValue={editData.authorizedEquipment}
          getOptionLabel={(option) => option.label}
          renderOption={(option: any) => (
            <React.Fragment>
              <ListItemText primary={option.label} />
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="normal"
              variant="outlined"
              placeholder={"Add Authorized Equipments"}
              style={{ width: "100%" }}
              error={errors.authorizedEquipment ? true : false}
              helperText={errors.authorizedEquipment?.name}
            />
          )}
        />
        <DialogActions>
          <Button
            onClick={() => {
              this.props.onClose();
            }}
          >
            {"CANCEL"}
          </Button>
          <Button type="submit" disabled={!isValid}>
            {editData.licenseNumber ? "Submit" : "SAVE"}
          </Button>
        </DialogActions>
      </Form>
    );
  };
  render() {
    const { open, editData, handleOnSubmit, dialogTitle } = this.props;
    let currentDay = new Date();
    currentDay = new Date(currentDay.setDate(currentDay.getDate() + 1));
    return (
      <Dialog
        onClose={() => this.handleClose()}
        aria-labelledby="simple-dialog-title"
        open={open}
        fullWidth
      >
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <Formik
            initialValues={
              editData && editData.licenseNumber
                ? editData
                : {
                    licenseNumber: "",
                    issuedDate: new Date(),
                    expiryDate: currentDay,
                    authorizedEquipment: {
                      name: "",
                      subtitle: "",
                    },
                  }
            }
            enableReinitialize={true}
            validationSchema={validationSchema}
            validateOnMount={true}
            onSubmit={(values, { resetForm }) => {
              handleOnSubmit(values);
              resetForm();
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              errors,
              isValid,
              touched,
              setFieldValue,
            }) => {
              return this.renderForm(
                values,
                handleChange,
                handleBlur,
                errors,
                isValid,
                touched,
                setFieldValue
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AddLicenseDetailsDialog);
